import { Sparkles } from 'lucide-react'

export default function PlaceholderPage({ title, sub, children }) {
  return (
    <main className="app-content">
      <header className="page-header">
        <div>
          <h1 className="page-header__title">{title}</h1>
          <div className="page-header__sub">{sub}</div>
        </div>
      </header>
      <section className="card card--lg empty-state" style={{ minHeight: 260 }}>
        <div className="col" style={{ alignItems: 'center', gap: 12 }}>
          <span
            style={{
              width: 44,
              height: 44,
              borderRadius: 14,
              background: 'var(--accent-soft)',
              color: 'var(--accent-strong)',
              display: 'grid',
              placeItems: 'center',
            }}
          >
            <Sparkles size={18} />
          </span>
          <div style={{ fontWeight: 600, color: 'var(--text-primary)' }}>Coming online soon</div>
          <div className="muted" style={{ maxWidth: 420, fontSize: 13 }}>
            {children || 'This module will come online as the rest of the prototype build ships.'}
          </div>
        </div>
      </section>
    </main>
  )
}
